module.exports = __webpack_public_path__ + "static/media/dustbox_base.b620bb03.png";